var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 22,
    viewBox: "0 0 28 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 4C0.447715 4 0 4.44772 0 5C0 5.55228 0.447715 6 1 6H27C27.5523 6 28 5.55228 28 5C28 4.44772 27.5523 4 27 4H1ZM1 16C0.447715 16 0 16.4477 0 17C0 17.5523 0.447715 18 1 18H27C27.5523 18 28 17.5523 28 17C28 16.4477 27.5523 16 27 16H1Z",
    fill: "#282624"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.12e7678a2a52607ff3efbc483fb16f30.svg";
export { ForwardRef as ReactComponent };